import { FC, useMemo } from "react";
import { ResourceExplorerGridDataWithId } from "@/store/resource-explorer/utils/types/resourceExplorerDataGrid";
import {
  ForecastedCost,
  ForecastOption,
  ResourceExplorerCostsDateDetails,
  ResourceExplorerGroupingNullable,
  WidgetCostBreakdownVisualization,
} from "@/services/cloudchipr.api";
import { AgDataGrid } from "@/components/pages/common/ag-grid/AgDataGrid";
import { getBillingExplorerWidgetAgGridColumnDefs } from "@/components/pages/dashboard/components/widgets/billing-explorer-widget/components/chart/ag-table/billingExplorerWidgetAgGridColumnDefs";
import {
  billingExplorerWidgetGridDefaultColDef,
  billingExplorerWidgetGridWrapperStyles,
} from "@/components/pages/dashboard/components/widgets/billing-explorer-widget/components/chart/ag-table/utils/constants/gridConstants";

interface BillingExplorerWidgetAgGridProps {
  loading?: boolean;
  totalItemsCount?: number;
  totalTrend: number | null;
  forecastOption?: ForecastOption;
  forecastedCost?: ForecastedCost;
  data: ResourceExplorerGridDataWithId[];
  grouping?: ResourceExplorerGroupingNullable;
  prevCostDates?: ResourceExplorerCostsDateDetails;
  visualization?: WidgetCostBreakdownVisualization;
  totalCostDates?: ResourceExplorerCostsDateDetails;
}

export const BillingExplorerWidgetAgGrid: FC<
  BillingExplorerWidgetAgGridProps
> = ({
  data,
  loading,
  grouping,
  totalTrend,
  visualization,
  prevCostDates,
  totalCostDates,
  forecastedCost,
  forecastOption,
  totalItemsCount,
}) => {
  const columnDefs = useMemo(
    () =>
      getBillingExplorerWidgetAgGridColumnDefs({
        grouping,
        totalTrend,
        prevCostDates,
        visualization,
        totalCostDates,
        forecastedCost,
        forecastOption,
        totalItemsCount,
      }),
    [
      grouping,
      totalTrend,
      prevCostDates,
      visualization,
      totalCostDates,
      forecastedCost,
      forecastOption,
      totalItemsCount,
    ],
  );

  return (
    <AgDataGrid
      rowHeight={40}
      rowData={data}
      headerHeight={56}
      loading={loading}
      columnDefs={columnDefs}
      defaultColDef={billingExplorerWidgetGridDefaultColDef}
      wrapperStyles={billingExplorerWidgetGridWrapperStyles}
    />
  );
};
